/*eslint-disable */
import React from "react";

function validateForm(check, data) {
    const {
        name,
        campus,
        city,
        location
    } = data;

    var errors =  {
        hasError: false,
        errorsObj: {}
    }




    let Validation = {
        name: {
            Validate: [{
                condition: !name.length,
                message: " Please Specify Your Center Name . ",
            }, {
                condition: /\d/.test(name) || /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(name),
                message: " Name Can Not Contain Numbers Or Any Special Character . ",
            }
            ],
            elem: "name"
        },
        campus: {
            Validate: [{
                condition: !campus.length,
                message: " Please Specify Campus . ",
            }
            ],
            elem: "campus"
        },
        city: {
            Validate: [{
                condition: !city.length,
                message: " Please Specify City Name . ",
            }, {
                condition: /\d/.test(city) || /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(city),
                message: " City Name Can Not Contain Numbers Or Any Special Character . ",
            }
            ],
            elem: "city"
        },
        location: {
            Validate: [{
                condition: !location.length,
                message: " Please Specify Location Of Center  . ",
            }, 
            ],
            elem: "location"
        }
        
    }
    console.log("Working1");
    
    if (check === "all") {
        for (var i in Validation) {
            var conArray = Validation[i].Validate;
            errors.errorsObj[Validation[i].elem] = { message: [] }
            for (var j = 0; j < conArray.length; j++) {
                if (conArray[j].condition) {
                    errors.hasError = true
                    errors.errorsObj[Validation[i].elem].message.push(conArray[j].message)
                }
            }
            if (!errors.errorsObj[Validation[i].elem].message.length) {
                delete errors.errorsObj[Validation[i].elem] ;
            }
        }
    }
    console.log("errors",errors);
    

    return Object.keys(errors).length>1 ? errors : {
        hasError: false
    }
}




export { validateForm };



